import * as React from 'react';
import { Helmet } from 'react-helmet-async';

import { config } from '@/config';
import { GuestGuard } from '@/components/auth/guest-guard';
import { Layout } from '@/components/auth/layout';
import { ResetPasswordForm } from '@/components/auth/reset-password-form';

export default function ResetPasswordPage(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>Reset password | Auth | {config.site.name}</title>
      </Helmet>
      <Layout>
        <GuestGuard>
          <ResetPasswordForm />
        </GuestGuard>
      </Layout>
    </>
  );
}
